import {getAppSessionCookieHeader, handleSessionId} from "../appCookie";
import api from "../../../Api";

export const getSessionUser = async (ref) => {
  const resp = await api.get('auth/user/cx?___ref=' + ref + getAppSessionCookieHeader())
    .then((response) => {
      handleSessionId(response);
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getMenu = async (ref) => {
  const resp = await api.get('cx/menu')
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getPortalCompanyBySubdomain = async (ref) => {
  const resp = await api.get('cx/company/subdomain/' + ref)
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const getPortalCompany = async () => {
  const resp = await api.get('cx/company')
    .then((response) => {
      return response.data;
    }).catch(function (error) {
      return handleError(error);
    });
  return resp;
}

export const login = async (auth) => {
  const resp = await api.post('auth/login' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const resetPass = async (auth) => {
  const resp = await api.post('auth/pass/reset' + getAppSessionCookieHeader(), auth).then((response) => {
    handleSessionId(response);
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}


export const getCustomerFamilyAll = async () => {
  const resp = await api.get('cx/family/all' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

export const getFamilyMemberTypes = async () => {
  const resp = await api.get('cx/familyMemberTypes' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  }).catch(function (error) {
    return handleError(error);
  });

  return resp;
}

function handleError(error) {
  let err = {
    error: true,
    message: error?.response?.data?.message || JSON.stringify(error)
  }
  return err;
}
